export default __webpack_public_path__ + "static/media/ham.f7e7fb48.svg";